/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class GisActionWorkflowConfigurationModel {
        public mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        public currentWorkflow: Wars.Domain.Model.Gis.GisActionWorkflowConfiguration;
        public currentActionBlock: Wars.Domain.Model.Gis.GisActionBlock;

        constructor(private mapConfigurationService: services.MapConfigurationService,
            mapConfigurationId: string) {

            this.mapConfigurationService.getMapConfiguration(mapConfigurationId).then(r => {
                this.mapConfiguration = r;
            });

            console.log(this);
        }

        public deleteWorkflow(workflow: Wars.Domain.Model.Gis.GisActionWorkflowConfiguration) {
            workflow.entityAspect.setDeleted();

            this.save();
        }

        public addWorkflow() {
            console.log('add workflow');

            let newWorkflow = this.mapConfigurationService.createGisActionWorkflowConfiguration();
            newWorkflow.name = "New Workflow";
            newWorkflow.isFeatureCollectionResult = false;
            newWorkflow.clearAllLayersAtCompletion = true;

            this.mapConfiguration.gisActionWorkflowConfigurations.push(newWorkflow);
            this.save();
        }

        public save() {
            this.mapConfigurationService.saveAllChanges();
        }

        public addGisActionBlock(blockType: Wars.Domain.Model.Codes.Enums.GisActionBlockType) {
            let newActionBlock = this.mapConfigurationService.createGisActionBlock();

            newActionBlock.name = "New Action Block";
            newActionBlock.gisActionBlockType = blockType;
            newActionBlock.workflowOrder = this.currentWorkflow.gisActionBlocks.length + 1;

            newActionBlock.inputCollection = this.mapConfigurationService.createGisInputOutputCollection();
            newActionBlock.outputCollection = this.mapConfigurationService.createGisInputOutputCollection();

            this.currentWorkflow.outputCollection = newActionBlock.outputCollection;
            this.currentWorkflow.outputCollection_id = newActionBlock.outputCollection_id;

            this.setOutputCollection(newActionBlock.outputCollection, blockType);

            if (this.currentWorkflow.gisActionBlocks.length > 0) {
                this.setInputCollection(newActionBlock.inputCollection, Enumerable.from(this.currentWorkflow.gisActionBlocks).orderBy(a => a.workflowOrder).last());
            }
            if (newActionBlock.gisActionBlockType == Wars.Domain.Model.Codes.Enums.GisActionBlockType.AddFeature) {
                this.currentWorkflow.isFeatureCollectionResult = true;
            } else {
                this.currentWorkflow.isFeatureCollectionResult = false;
            }
            this.currentWorkflow.gisActionBlocks.push(newActionBlock);
            this.currentActionBlock = newActionBlock;

            return newActionBlock;
        }

        private setInputCollection(inputCollection: Wars.Domain.Model.Gis.GisInputOutputCollection,
                                   previousActionBlock: Wars.Domain.Model.Gis.GisActionBlock) {

            if (previousActionBlock && previousActionBlock.outputCollection && previousActionBlock.outputCollection.gisInputOutputs.length > 0) {
                previousActionBlock.outputCollection.gisInputOutputs.forEach(g => {
                    let newInput = this.mapConfigurationService.createGisInputOutput();

                    newInput.name = g.name;
                    newInput.type = g.type;
                    newInput.relatedGisInputOutput = g;

                    inputCollection.gisInputOutputs.push(newInput);
                });
            }
        }

        private setOutputCollection(outputCollection: Wars.Domain.Model.Gis.GisInputOutputCollection,
                                    type: Wars.Domain.Model.Codes.Enums.GisActionBlockType) {

            let newInputOutput = this.mapConfigurationService.createGisInputOutput();

            switch (type) {
                case Wars.Domain.Model.Codes.Enums.GisActionBlockType.DrawFeature:
                    newInputOutput.name = "Geometry";
                    newInputOutput.type = Wars.Domain.Model.Codes.Enums.GisInputOutputType.Geometry;
                    break;
                case Wars.Domain.Model.Codes.Enums.GisActionBlockType.QueryEsriQuery:
                    newInputOutput.name = "Query Result";
                    newInputOutput.type = Wars.Domain.Model.Codes.Enums.GisInputOutputType.FeatureCollection;
                    break;
                case Wars.Domain.Model.Codes.Enums.GisActionBlockType.Trim:
                    newInputOutput.name = "Trim Result";
                    newInputOutput.type = Wars.Domain.Model.Codes.Enums.GisInputOutputType.FeatureCollection;
                    break;
                case Wars.Domain.Model.Codes.Enums.GisActionBlockType.Filter:
                    newInputOutput.name = "Filter Result";
                    newInputOutput.type = Wars.Domain.Model.Codes.Enums.GisInputOutputType.FeatureCollection;
                    break;
                case Wars.Domain.Model.Codes.Enums.GisActionBlockType.AddFeature:
                    newInputOutput.name = "Add Features Result";
                    newInputOutput.type = Wars.Domain.Model.Codes.Enums.GisInputOutputType.ListofGisDatastoreFeatures;
                    break;
                case Wars.Domain.Model.Codes.Enums.GisActionBlockType.BufferGeometry:
                    newInputOutput.name = "Buffered Geometry";
                    newInputOutput.type = Wars.Domain.Model.Codes.Enums.GisInputOutputType.Geometry;
                    break;
                case Wars.Domain.Model.Codes.Enums.GisActionBlockType.SetProperty:
                    newInputOutput.name = "Feature Collection";
                    newInputOutput.type = Wars.Domain.Model.Codes.Enums.GisInputOutputType.FeatureCollection;
                    break;
                case Wars.Domain.Model.Codes.Enums.GisActionBlockType.Validation:
                    newInputOutput.name = "Validation Result";
                    newInputOutput.type = Wars.Domain.Model.Codes.Enums.GisInputOutputType.ValidationResult;
                    break;
                default:

            }

            if (newInputOutput) {
                outputCollection.gisInputOutputs.push(newInputOutput);
            }
        }

        public addDrawFeatureActionBlock() {
            let newActionBlock = this.addGisActionBlock(Wars.Domain.Model.Codes.Enums.GisActionBlockType.DrawFeature);

            newActionBlock.drawFeatureConfiguration = this.mapConfigurationService.createDrawFeatureConfiguration();

            this.save();
        }

        public addTrimActionBlock() {
            let newActionBlock = this.addGisActionBlock(Wars.Domain.Model.Codes.Enums.GisActionBlockType.Trim);

            newActionBlock.trimConfiguration = this.mapConfigurationService.createTrimConfiguration();

            this.save();
        }

        public addBufferBlock() {
            let newActionBlock = this.addGisActionBlock(Wars.Domain.Model.Codes.Enums.GisActionBlockType.BufferGeometry);

            newActionBlock.bufferConfiguration = this.mapConfigurationService.createBufferConfiguration();
            newActionBlock.bufferConfiguration.bufferDistance = 100;
            newActionBlock.bufferConfiguration.showBuffer = false;

            this.save();
        }

        public addFilterActionBlock() {
            let newActionBlock = this.addGisActionBlock(Wars.Domain.Model.Codes.Enums.GisActionBlockType.Filter);

            newActionBlock.filterFeatureCollectionConfiguration = this.mapConfigurationService.createFilterFeatureCollectionConfiguration();
            newActionBlock.filterFeatureCollectionConfiguration.useFilterFunction = false;
            this.save();
        }

        public addValidationBlock() {
            let newActionBlock = this.addGisActionBlock(Wars.Domain.Model.Codes.Enums.GisActionBlockType.Validation);

            newActionBlock.gisActionValidationConfiguration = this.mapConfigurationService.createValidationConfiguration();

            newActionBlock.gisActionValidationConfiguration.exitWorkflowOnFailure = true;
            newActionBlock.gisActionValidationConfiguration.validationMessage="Validation Message";
            newActionBlock.gisActionValidationConfiguration.useJavascriptFunction = false;
            newActionBlock.gisActionValidationConfiguration.checkAnyFeatures=true;

            this.save(); 
        }

        public addSetPropertyBlock() {
            let newActionBlock = this.addGisActionBlock(Wars.Domain.Model.Codes.Enums.GisActionBlockType.SetProperty);

            newActionBlock.setPropertyConfiguration = this.mapConfigurationService.creatSetPropertyConfiguration();
            newActionBlock.setPropertyConfiguration.useJavascriptTransformer = false;
            newActionBlock.setPropertyConfiguration.useJsonDictionaryStore = false;

            this.save(); 
        }

        public addEsriQueryActionBlock() {
            let newActionBlock = this.addGisActionBlock(Wars.Domain.Model.Codes.Enums.GisActionBlockType.QueryEsriQuery);

            newActionBlock.gisActionBlockEsriQueryConfiguration = this.mapConfigurationService.createGisActionBlockEsriQueryConfiguration();
            this.save();
        }

        public addFeaturesBlock() {
            let newActionBlock = this.addGisActionBlock(Wars.Domain.Model.Codes.Enums.GisActionBlockType.AddFeature);

            newActionBlock.addFeaturesConfiguration= this.mapConfigurationService.createAddFeaturesConfiguration();
            newActionBlock.addFeaturesConfiguration.filterPropertiesToMappedAttributes= false;

            this.save();
        }

        public addGisDatastoreQueryActionBlock() {
            let newActionBlock = this.addGisActionBlock(Wars.Domain.Model.Codes.Enums.GisActionBlockType.QueryGisDatastore);
            newActionBlock.gisDatastoreQueryConfiguration = this.mapConfigurationService.createGisDatastoreQueryConfiguration();

            this.save();
        }

        public deleteActionBlock() {
            this.currentActionBlock.entityAspect.setDeleted();
            this.currentActionBlock = null;
            this.save();
        }

    }
}